import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitPagesPage.module.scss';

const Page = ({ children, className = '' }) => (
  <div className={classnames(styles.element, className)}>
    {children}
  </div>
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default React.memo(Page);
